import { Component, ElementRef, ViewChild } from '@angular/core';
import { CustomizationFrameworkService } from '../../../../shared-modules/customization-framework/customization-framework.service';
import { LoginService } from '../../../../shared-modules/login/login.service';
import { YearService } from '../../../year/year.service';
import { DataDefControl } from '../data-def-control.directive';

@Component({
    selector: 'data-def-radio-buttons',
    templateUrl: './data-def-radio-buttons.component.html',
    styleUrls: ['./data-def-radio-buttons.component.css']
})
export class DataDefRadioButtonsComponent extends DataDefControl {

    labels: string[] = [];
    values: any[] = [];
    ids: string[] = [];

    private _controlRef: ElementRef;
    get controlRef(): ElementRef {
        return this._controlRef;
    }
    @ViewChild('control', { read: ElementRef }) set controlRef(value: ElementRef) {
        this._controlRef = value;
        this.controlEmitter.emit(value);
    }

    constructor(
        customizationFrameworkService: CustomizationFrameworkService,
        yearService: YearService,
        loginService: LoginService
    ) {
        super(customizationFrameworkService, yearService, loginService);
    }

    processOptions(): void {
        this.labels = this.options.map(opt => (this.dataDef.CodeNotRequired ? '' : (opt.Code ? opt.Code : '') + ' - ') + (opt.Description ? opt.Description : ''));
        this.values = this.options.map(o => this.useCodeAsValue ? o.Code : o.Id);
        this.ids = this.options.map(o => this.dataDef.Enum + '-opt-' + o.Id);
    }

}
